<template>
  <!-- Header -->
  <header class="masthead">
    <div class="container">
      <div class="intro-text">
        <div class="intro-lead-in">Bienvenido!</div>
        <div class="intro-heading text-uppercase">es un placer conocerte...</div>
        <a
          class="btn btn-primary btn-xl text-uppercase js-scroll-trigger"
          href="#services"
        >Queres conocer más</a>
      </div>
    </div>
  </header>
</template>
<script>
export default {
  name: "header-component"
};
</script>
<style>

</style>


// WEBPACK FOOTER //
// src/components/headerComponent/headerComponent.vue